module.exports = __webpack_public_path__ + "img/logo-danantara.12debddc.svg";